module.exports = __webpack_public_path__ + "img/yjk03.8e2991fa.png";